import React, { useEffect, useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import {
    AiOutlineUnorderedList,
    AiOutlineCar,
    AiOutlineDashboard,
    AiOutlineUser,
    AiTwotoneFileImage,
    AiFillBank,
    AiOutlineFundProjectionScreen,
    AiFillAlert,
    AiOutlineBgColors,
    AiFillCustomerService,
    AiFillContainer
} from "react-icons/ai";
import { BiCategoryAlt, BiCustomize } from "react-icons/bi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { IoIosNotifications } from "react-icons/io";
import { Layout, Menu, Grid, theme } from "antd";
import { getUserFromLocalStorage } from "../utils/localstorage";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const { Header, Sider, Content } = Layout;
const { useBreakpoint } = Grid;

const MainLayout = () => {
    const [userData, setUserData] = useState(null);
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    const auth = getAuth();
    const screens = useBreakpoint();

    useEffect(() => {
        const user = getUserFromLocalStorage();
        setUserData(user);

        // Set collapsed to true if the screen width is less than 768px
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setCollapsed(true);
            }
        };

        // Add event listener to handle screen resize
        window.addEventListener("resize", handleResize);

        // Check screen size on initial load
        handleResize();

        // Clean up event listener on component unmount
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleLogout = () => {
        auth.signOut();
        localStorage.removeItem("user");
        toast.success("You are logged out");

        setTimeout(() => {
            navigate("/");
        }, 1000);
    };

    const handleMenuClick = ({ key }) => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                navigate(key);
            } else {
                toast.error("You must be logged in");
                setTimeout(() => {
                    navigate("/"); // Change "/login" to the actual login page route
                }, 1000);
            }
        });
    };

    const {
        token: { colorBgContainer },
    } = theme.useToken();

    return (
        <Layout>
            <Sider trigger={null} collapsible collapsed={collapsed}>
                <div className="logo">
                    <h2
                        className="text-white fs-5 text-center py-2 mb-0"
                        style={{ background: "white" }}
                    >
                        <span className="sm-logo">
                            <img src="/images/small.png" width={50} alt="Logo" />
                        </span>
                        <span className="lg-logo">
                            <img
                                src="/images/logo2.png"
                                width={"100%"}
                                style={{ objectFit: "cover" }}
                                alt="Logo"
                            />
                        </span>
                    </h2>
                </div>
                <Menu
                    theme="dark"
                    mode="inline"
                    defaultSelectedKeys={[""]}
                    onClick={handleMenuClick}
                    items={[
                        {
                            key: "",
                            icon: <AiOutlineDashboard className="fs-4" />,
                            label: "Dashboard",
                        },
                        {
                            key: "Add-category-manager",
                            icon: <BiCategoryAlt className="fs-4" />,
                            label: "Add Category",
                        },
                        {
                            key: "Add-Types",
                            icon: <AiOutlineUnorderedList className="fs-4" />, // Use an appropriate type-related icon
                            label: "Add Types",
                        },
                        {
                            key: "Add-Cars",
                            icon: <AiOutlineCar className="fs-4" />, // Use an appropriate car-related icon
                            label: "Add Cars",
                        },
                        {
                            key: "Main-sub-category",
                            icon: <AiOutlineBgColors className="fs-4" />,
                            label: "MainSubCategory",
                        },
                        {
                            key: "Add-subcategory-manager",
                            icon: <BiCustomize className="fs-4" />,
                            label: "Add SubCategory",
                        },
                        {
                            key: "Add-business-tools",
                            icon: <AiFillCustomerService className="fs-4" />,
                            label: "Create Business Tools",
                        },
                        {
                            key: "All-users",
                            icon: <AiOutlineUser className="fs-4" />,
                            label: "All Users",
                        },
                        {
                            key: "Upload-banners",
                            icon: <AiTwotoneFileImage className="fs-4" />,
                            label: "Upload Banners",
                        },
                        {
                            key: "publish-A-News",
                            icon: <AiFillAlert className="fs-4" />,
                            label: "News and Alerts",
                        },
                        {
                            key: "Products-Manager",
                            icon: <AiOutlineFundProjectionScreen className="fs-4" />,
                            label: "Add Products",
                        },
                        {
                            key: "Product-Deals",
                            icon: <AiFillBank className="fs-4" />,
                            label: "Create Deals",
                        },
                        {
                            key: "Products-Color-Code",
                            icon: <AiOutlineBgColors className="fs-4" />,
                            label: "Add-Product-color",
                        },

                        {
                            key: "Template-Type-Manager",
                            icon: <AiFillContainer className="fs-4" />,
                            label: "TemplateTypeManager",
                        },

                        {
                            key: "Add-Templates",
                            icon: <AiFillContainer className="fs-4" />,
                            label: "TemplateCRUD",
                        },

                        {
                            key: "Add-Size",
                            icon: <AiFillContainer className="fs-4" />,
                            label: "AddSize/Price",
                        },

                        {
                            key: "Add-Template-Data",
                            icon: <AiFillContainer className="fs-4" />,
                            label: "TemplateSideData",
                        },

                    ]}
                />
            </Sider>
            <Layout className="site-layout">
                <Header
                    className="sticky-top d-flex justify-content-between ps-1 pe-5"
                    style={{
                        padding: 0,
                        background: colorBgContainer,
                    }}
                >
                    {React.createElement(
                        collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                        {
                            className: "trigger",
                            onClick: () => setCollapsed(!collapsed),
                        }
                    )}
                    <div className="d-flex gap-4 align-items-center">
                        <div className="position-relative">
                            <IoIosNotifications className="fs-4" />
                            <span className="badge bg-warning rounded-circle p-1 position-absolute">
                                3
                            </span>
                        </div>
                        <div className="d-flex gap-3 align-items-center dropdown">
                            <div>
                                <img
                                    width={32}
                                    height={32}
                                    src="/images/small.png"
                                    className="object-fit-contain"
                                    alt="User"
                                />
                            </div>
                            {userData ? (
                                <>
                                    <div
                                        role="button"
                                        id="dropdownMenuLink"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        {/* Display user info only if screen is not extra small */}
                                        {!screens.xs && (
                                            <>
                                                <h5 className="mb-0">Admin</h5>
                                                <p className="mb-0">{userData.email}</p>
                                            </>
                                        )}
                                    </div>
                                    <div
                                        className="dropdown-menu"
                                        aria-labelledby="dropdownMenuLink"
                                    >
                                        <li>
                                            <Link
                                                className="dropdown-item py-1 mb-1"
                                                style={{ height: "auto", lineHeight: "20px" }}
                                            >
                                                View Profile
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                className="dropdown-item py-1 mb-1"
                                                style={{ height: "auto", lineHeight: "20px" }}
                                                onClick={handleLogout}
                                            >
                                                Sign out
                                            </Link>
                                        </li>
                                    </div>
                                </>
                            ) : (
                                <div className="">
                                    <Link to="/" className="nav-link">
                                        <b>Login</b>
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>
                </Header>
                <Content
                    style={{
                        background: colorBgContainer,
                    }}
                >
                    <ToastContainer
                        position="top-right"
                        autoClose={250}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        theme="light"
                    />
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
};

export default MainLayout;
